// Acta de entrega de equipos en alquiler (31-oct-2026), diseño limpio como el resto.
// Es la constancia de que la empresa recibió los equipos instalados y funcionando: qué equipos (con N/S),
// dónde, cuándo y quién los recibió (nombre, DNI, cargo y firma). La firma en pantalla es firma electrónica
// (Ley 25.506): por eso van la aclaración, el DNI, la fecha y la hora junto a la firma.
import { CONTENT_W, M } from '../theme.js';
import { datos, tabla, firmas, colCliente, texto, rotulo, espacio, F } from './base.js';

/**
 * e = {
 *   equipos: [{ equipo, numeroSerie, ubicacion }],
 *   recibe: { nombre, dni, cargo }, firmaRecibe, firmaEntrega, entrega: 'Lucas Brandán',
 *   fecha, hora, referencia,   // referencia: N° de la propuesta o contrato (opcional)
 *   observaciones,
 * }
 */
export function generarActaEntregaV2(doc, { ctx, cliente, sede, y, e }) {
    const equipos = (e.equipos || []).filter(q => q.equipo || q.numeroSerie);
    y = datos(doc, y, colCliente(cliente, sede), {
        rotulo: 'Recibe',
        nombre: e.recibe?.nombre || '—',
        lineas: [
            [e.recibe?.dni && `DNI ${e.recibe.dni}`, e.recibe?.cargo].filter(Boolean).join(' · '),
            `${e.fecha}${e.hora ? ` · ${e.hora} h` : ''}`,
            e.referencia ? `Según propuesta N° ${e.referencia}` : null,
        ],
    });

    y = tabla(doc, ctx, y, [{ titulo: '#', ancho: 8 }, { titulo: 'Equipo' }, { titulo: 'N/S', ancho: 42 }, { titulo: 'Ubicación', ancho: 40 }],
        equipos.map((q, i) => [String(i + 1), q.equipo || 'Dispenser', q.numeroSerie || 's/n', q.ubicacion || '']), { negritaCol: 2 });

    const declaracion = `En la fecha indicada, ${cliente?.nombre || 'la empresa'} recibe ${equipos.length} `
        + `${equipos.length === 1 ? 'equipo instalado y funcionando, detallado' : 'equipos instalados y funcionando, detallados'} arriba, `
        + 'en alquiler. Los equipos son propiedad de Dispenser La Tienda y se devuelven al terminar el contrato. '
        + 'Mientras estén en el lugar, la empresa los cuida y da aviso ante cualquier falla; no se mueven ni los '
        + 'manipulan terceros sin coordinarlo con Dispenser La Tienda.';
    doc.setFontSize(F.texto);
    const renglones = doc.splitTextToSize(declaracion, CONTENT_W);
    y = espacio(doc, ctx, y + 6, renglones.length * 3.9 + 8);
    rotulo(doc, 'Constancia', M, y);
    texto(doc, declaracion, M, y + 5, { ancho: CONTENT_W });
    y += 5 + renglones.length * 3.9 + 3;

    const obs = String(e.observaciones || '').trim();
    if (obs) {
        const r = doc.splitTextToSize(obs, CONTENT_W);
        y = espacio(doc, ctx, y, r.length * 3.9 + 8);
        rotulo(doc, 'Observaciones', M, y);
        texto(doc, obs, M, y + 5, { ancho: CONTENT_W });
        y += 5 + r.length * 3.9 + 3;
    }

    return firmas(doc, ctx, y + 8, {
        firmaCliente: e.firmaRecibe, firmaTecnico: e.firmaEntrega,
        aclaracionCliente: [e.recibe?.nombre, e.recibe?.dni && `DNI ${e.recibe.dni}`].filter(Boolean).join(' · '),
        aclaracionTecnico: e.entrega || 'Dispenser La Tienda', rolTecnico: 'Entrega · Dispenser La Tienda',
    });
}
